/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/PracticeHub/InviteAction/Content/PermittedToSeePatientInfo/Content",
  onChange
  
}) {
let selectedPermittedToSeeInfoValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'permitted_to_see_info',
})
let selectedPermittedToSeeInfoChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'permitted_to_see_info',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginTop={dtSpaceS}
 data="selected.permitted_to_see_info"
 required={true}
 validate="helpers.js isChecked"
 value={selectedPermittedToSeeInfoValueData}
 onChange={selectedPermittedToSeeInfoChangeData}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Permitted to see patient info in the Practice Hub"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}